import { DI } from '@intigral/constant/config/DIContainer';
import { container } from '../../../DataDomain';
import { ICustomConfigurationRepository } from '../../repositories/interfaces/iCustomConfigurationRepository';
import { IGetFooterMenuResponse } from '../../../entity/interface/iGetFooterMenu';

export interface IGetFooterMenuContentUseCase {
    execute(): Promise<IGetFooterMenuResponse>;
}

export class GetFooterMenuContentUseCase implements IGetFooterMenuContentUseCase {
    // Lazy getter for repository to avoid circular dependencies
    private get customConfigurationRepository(): ICustomConfigurationRepository {
        return container.resolve<ICustomConfigurationRepository>(DI.REPOSITORIES.ICustomConfigurationRepository);
    }

    constructor() {
        // No initialization needed - dependencies resolved lazily via getters
    }

    async execute(): Promise<IGetFooterMenuResponse> {
        const response = await this.customConfigurationRepository.getFooterMenuContent();
        return response;
    }
}
